import { render, staticRenderFns } from "./NicheOrderCreate.vue?vue&type=template&id=37843a08"
import script from "./NicheOrderCreate.vue?vue&type=script&lang=js"
export * from "./NicheOrderCreate.vue?vue&type=script&lang=js"
import style0 from "./NicheOrderCreate.vue?vue&type=style&index=0&id=37843a08&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports